import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialUiModule } from '@cpd-app/shared-module/material-ui-module/material-ui.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { FlatButtonComponent } from './flat-button/flat-button.component';
import { StrokedButtonComponent } from './stroked-button/stroked-button.component';
import { LinkButtonComponent } from './link-button/link-button.component';

@NgModule({
  imports: [CommonModule, MaterialUiModule, FontAwesomeModule],
  declarations: [
    FlatButtonComponent,
    StrokedButtonComponent,
    LinkButtonComponent
  ],
  exports: [FlatButtonComponent, StrokedButtonComponent, LinkButtonComponent]
})
export class ButtonModule {}
